import { render } from "./AppMenu.vue?vue&type=template&id=3e9e8a28&scoped=true&ts=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"

import "./AppMenu.vue?vue&type=style&index=0&id=3e9e8a28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9e8a28"]])

export default __exports__